module.exports = __webpack_public_path__ + "images/js_src_vue/page_price_versions/nutstore_robot-035e81ca.png";